import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const reviews = [
  { name: "A happy customer", text: "Absolutely beautiful candles — the fragrance filled my whole living room. Packaging was gorgeous too.", },
  { name: "Google Reviewer", text: "Ordered a floral candle bouquet as a gift. It looked stunning and felt so premium. Highly recommend!", },
  { name: "Local buyer", text: "The DIY plaster kit kept my kids happily busy for hours. Great quality and lovely to paint.", },
];

export default function Reviews() {
  return (
    <section id="reviews" className="border-y border-[#292524] bg-[#1C1917]/40" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-6 py-28 sm:py-36">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-[#C4A47C]" />
                <span className="label text-[#C4A47C]">Loved by locals</span>
              </div>
              <h2 className="font-serif font-light text-4xl sm:text-6xl tracking-tighter text-[#F5F5F0]">
                Rated 5.0 on Google.
              </h2>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={22} className="fill-[#C4A47C] text-[#C4A47C]" strokeWidth={0} />
                ))}
              </div>
              <span className="font-serif text-3xl text-[#F5F5F0]">5.0</span>
            </div>
          </div>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <div className="h-full border border-[#292524] rounded-sm p-8 bg-[#0C0A09]/40" data-testid={`review-card-${i}`}>
                <Quote size={28} className="text-[#C4A47C]" strokeWidth={1} />
                <p className="mt-6 text-[#F5F5F0]/90 font-light leading-relaxed">"{r.text}"</p>
                <div className="mt-8 flex items-center gap-3">
                  <div className="flex">
                    {[...Array(5)].map((_, j) => (
                      <Star key={j} size={14} className="fill-[#C4A47C] text-[#C4A47C]" strokeWidth={0} />
                    ))}
                  </div>
                  <span className="label">{r.name}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
